import React from 'react';
import { ArrowRight, Clock, Wrench, ThermometerSun, DollarSign, Calculator, Droplets, ShieldCheck, Ruler } from 'lucide-react';

const ALL_ARTICLES = {
  '/check-ac-age': {
    title: 'How Old Is My AC Unit?',
    description: 'Decode your serial number to find your system\'s manufacturing date.',
    icon: Clock,
    color: 'text-[#0EA5E9]',
  },
  '/ac-unit-lifespan-louisiana': {
    title: 'AC Lifespan in Louisiana',
    description: 'How humidity and salt air shorten your system\'s life.',
    icon: ThermometerSun,
    color: 'text-[#F97316]',
  },
  '/repair-vs-replace-ac': {
    title: 'Repair vs. Replace Guide',
    description: 'Use the $5,000 rule to decide if replacement makes sense.',
    icon: Wrench,
    color: 'text-[#0F172A]',
  },
  '/hvac-pricing-new-orleans': {
    title: 'HVAC Pricing New Orleans',
    description: 'See transparent pricing for heating and cooling services.',
    icon: DollarSign,
    color: 'text-green-600',
  },
  '/ac-replacement-cost-new-orleans': {
    title: 'AC Replacement Costs',
    description: 'Get accurate replacement cost estimates for New Orleans.',
    icon: Calculator,
    color: 'text-[#0EA5E9]',
  },
  '/hvac-refrigerant-guide': {
    title: 'HVAC Refrigerant Guide',
    description: 'R-22 vs R-410A vs new refrigerants — what homeowners need to know.',
    icon: Droplets,
    color: 'text-[#0EA5E9]',
  },
  '/compare-hvac-contractors': {
    title: 'Compare HVAC Contractors',
    description: 'What to look for when choosing an HVAC contractor.',
    icon: ShieldCheck,
    color: 'text-[#0F172A]',
  },
  '/what-size-ac-unit-do-i-need': {
    title: 'What Size AC Do I Need?',
    description: 'HVAC sizing guide for Louisiana homeowners.',
    icon: Ruler,
    color: 'text-[#F97316]',
  },
};

const RelatedArticles = ({ currentPath }) => {
  const articles = Object.entries(ALL_ARTICLES)
    .filter(([path]) => path !== currentPath)
    .slice(0, 4);

  return (
    <section className="py-16 bg-slate-50" data-testid="related-articles-section">
      <div className="max-w-4xl mx-auto px-6">
        <h2
          className="text-2xl font-bold text-[#0F172A] mb-2"
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          Related Articles
        </h2>
        <p className="text-slate-500 mb-8">Keep reading to make a smarter HVAC decision.</p>

        <div className="grid sm:grid-cols-2 gap-4">
          {articles.map(([path, article]) => (
            <a
              key={path}
              href={path}
              data-testid={`related-article-${path.replace(/\//g, '-').slice(1)}`}
              className="group flex items-start gap-4 p-5 bg-white rounded-xl border border-slate-200 hover:border-[#0EA5E9] hover:shadow-md transition-all duration-300"
            >
              <div className="w-10 h-10 bg-slate-50 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-sky-50 transition-colors">
                <article.icon className={`w-5 h-5 ${article.color}`} />
              </div>
              <div className="min-w-0">
                <h3 className="font-bold text-[#0F172A] text-sm group-hover:text-[#0EA5E9] transition-colors flex items-center gap-1">
                  {article.title}
                  <ArrowRight className="w-3.5 h-3.5 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                </h3>
                <p className="text-slate-500 text-xs mt-1">{article.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedArticles;
